import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import classes from "./Opener2.module.css";
import { testUrl } from "../BaseData";

export const Opener2 = () => {
    const { t, i18n } = useTranslation();
    const [newsData, setNewsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // Stacked animation state
    const [activeIndex, setActiveIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        const fetchNewsData = axios.get(
            testUrl + "/api/newsthree/"
        );

        Promise.all([fetchNewsData])
            .then(([newsResponse]) => {
                const news_data = newsResponse.data || [];
                if (Array.isArray(news_data)) {
                    setNewsData(news_data);
                } else {
                    setError("Ma'lumotlar topilmadi");
                }
            })
            .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
            .finally(() => setLoading(false));
    }, [t]);

    const next = useCallback(() => {
        if (isAnimating || newsData.length < 2) return;
        setIsAnimating(true);
        setActiveIndex((prev) => (prev + 1) % newsData.length);

        setTimeout(() => {
            setIsAnimating(false);
        }, 250);
    }, [isAnimating, newsData.length]);

    // Auto-advance every 3.5s
    useEffect(() => {
        if (newsData.length < 2) return;
        const timer = setInterval(next, 3500);
        return () => clearInterval(timer);
    }, [next, newsData.length]);

    return (
        <div id="opener" className={classes.wrapper}>
            <video
                autoPlay
                muted
                loop
                playsInline
                className={classes["video-background"]}
            >
                <source src="/video/bg2.mp4" type="video/mp4" />
            </video>
            <div className={classes.mainContainer}>
                {/* Hero Section */}
                <div data-aos="fade-up" className={classes.container}>
                    <h1 className={classes.title}>
                        <span className="span_bluem">
                            {t("openerTitleSpan")}
                        </span>
                    </h1>
                    <p className={classes.descr}>
                        {t("openerDescr")}
                    </p>
                </div>

                {/* News Stacked Cards Section */}
                <div className={classes.container2}>
                    <h2 className={classes.newsTitle}>
                        {t("newsTitles")}
                    </h2>

                    <div className={classes.newsSection}>
                        {loading ? (
                            <p>{t("loading")}</p>
                        ) : error ? (
                            <p>{error}</p>
                        ) : (
                            <div className={classes.deckWrapper}>
                                <div className={classes.deck}>
                                    {newsData.map((item, index) => {
                                        let dist = (index - activeIndex) % newsData.length;
                                        if (dist < 0) dist += newsData.length;

                                        let layerClass = classes.hidden;
                                        if (dist === 0) layerClass = classes.top;
                                        else if (dist === 1) layerClass = classes.mid;
                                        else if (dist === 2) layerClass = classes.back;

                                        if (dist === newsData.length - 1 && newsData.length > 1) {
                                            if (isAnimating) {
                                                layerClass = classes.flyOut;
                                            } else {
                                                if (newsData.length === 2) layerClass = classes.mid;
                                                else if (newsData.length === 3) layerClass = classes.back;
                                                else layerClass = classes.hidden;
                                            }
                                        }

                                        return (
                                            <div
                                                key={item.id}
                                                className={`${classes.card} ${layerClass}`}
                                                onClick={dist === 0 ? next : undefined}
                                            >
                                                {/* If image exists show it, else fallback */}
                                                {item.image && (
                                                    <img
                                                        src={item.image}
                                                        alt={item.title_uz}
                                                        className={classes.cardImg}
                                                    />
                                                )}
                                                <div className={classes.cardOverlay}>
                                                    <h3 className={classes.cardTitle}>
                                                        {item[`title_${i18n.language}`] || item.title_uz}
                                                    </h3>
                                                    <p className={classes.cardDate}>
                                                        {item.posted_time ? new Date(item.posted_time).toLocaleDateString() : ""}
                                                    </p>
                                                    <button
                                                        className={classes.readBtn}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            navigate("/news");
                                                        }}
                                                    >
                                                        Batafsil →
                                                    </button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Opener2;
